module.exports = __webpack_public_path__ + "img/hot.a5761bc.png";